import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { UserAccessService } from '../../../services/user-access.service';
import { RolePermission } from '../../../models/Securable';
import { Form, FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { FormsValidationService } from 'app/shared/services/formsValidation.service';
import { FieldType, FormatService } from 'app/shared/services/format.service';

@Component({
    selector: 'sec-input-group',
    templateUrl: './securable-form-input-component.html'
    //styleUrls: ['./header.component.scss']
})
export class SecurableFormInputComponent implements OnInit {

    @Input('SEC') securableName: string; //Keep consistency [SEC] = securable name
    @Input('Editing') editing: boolean; //Required Editing t/f
    @Input('Form') parentForm: FormGroup; //Required form object
    @Input('FormControlName') formCtrlName: string //form control name it's bound to
    @Input('Label') label: string //Required label for the form element

    @Input('InputType') inputType: string = "text"; //Optional input type for the form input
    @Input('SEID') salesEntityID: number; //Optional Sales Entity ID for specific permissions
    @Input('MID') merchantID: number; //Optional merchant ID for specific permissions
    @Input('SubID') subObjID: number; //Optional sub object ID when present must be sent along with the request for securables
    @Input('CHANGE') change: boolean; //Optional input to force change control to trigger can be flipped on/off (places where we can't use editing)
    @Input('DataCollection') DataCollection: Array<any>; //Optional Dropdown DataCollection
    @Input('ddlValue') ddlValue: string; //Conditionally required Dropdown Value Property Name
    @Input('ddlText') ddlText: string; //Conditionally required Dropdown Text Property Name
    @Input('FormatType') formatType: string = 'NONE'; //Optional Formatter Type

    private readonly debug = false;

    constructor(private formSvc: FormsValidationService, private formatSvc: FormatService) {
        //construct stuff
    }

    ngOnChanges() { //Input change events
        if (this.debug) { console.log("securableName", this.securableName); }
        if (this.debug) { console.log("editing", this.editing); }
        if (this.debug) { console.log("parentForm", this.parentForm); }
        if (this.debug) { console.log("formCtrlName", this.formCtrlName); }
        if (this.debug) { console.log("label", this.label); }
        if (this.debug) { console.log("subObjID", this.subObjID); }
        if (this.debug) { console.log("formatType", this.formatType); }
    }

    ngOnInit() { //init (inputs available now)

        //Guard clauses
        if (!(this.securableName)) { throw ('Form for securable form component is required.'); }
        if (!(this.editing)) { throw ('Editing for securable form component is required.'); }
        if (!(this.parentForm)) { throw ('Parent Form for securable form component is required.'); }
        if (!(this.formCtrlName)) { throw ('Form Control Name for securable form component is required.'); }
        if (!(this.label)) { throw ('Label for securable form component is required.'); }
        if (this.DataCollection) {
            if (!(this.ddlText)) { throw ('Dropdown Text Property Name is required when using securable input control dropdown'); }
            if (!(this.ddlValue)) { throw ('Dropdown Value Property Name is required when using securable input control dropdown'); }
        }
    }

    ngAfterViewInit() {

    }

    /**
     * Formats the field targeted by the event according to passed in format type
     * @param event Event listened to
     */
    public formatField(event: any) {
        //console.log("FormatField format type:", this.formatType);
        var ftype: FieldType = FieldType[this.formatType];
        if (ftype !== FieldType.NONE) {
            let tag = event.target ? event.target : event.srcElement;
            //console.log("FormatField:", event, tag, ftype);
            let formatted = this.formatSvc.FormatByType(ftype, tag.value);
            (<FormControl> this.parentForm.controls[this.formCtrlName]).setValue(formatted);
        }
    }

    /**
     * Returns true if the form control is required
     * @param control control to check
     */
    public isRequired(control: AbstractControl) {
        return this.formSvc.isControlRequired(control);
    }
    public SubObjectID(){
        return (this.subObjID == null) ? undefined : this.subObjID;
    }
}